<template>
  <div id="gSkeleton" :class="['g-skeleton', className]">
    <div class="s-banner"></div>

    <div class="detail-wrap">
      <div class="content-wrap s-base-info">
        <div class="sku-list">
          <div class="sku-selected"></div>
        </div>
        <div class="info">
          <div class="block main"></div>
          <div class="g-block2">
            <div class="block left"></div>
            <div class="block center"></div>
            <div class="block right"></div>
          </div>
        </div>
      </div>

      <div class="content-wrap m2">
        <div class="g-block b1"></div>
        <div class="g-block b2"></div>
        <div class="tag">
          <div class="g-block b3"></div>
          <div class="g-block b4"></div>
        </div>
        <div class="g-top attr">
          <div class="g-block b-small"></div>
          <div class="g-block b5"></div>
        </div>
      </div>

      <div class="content-wrap m3">
        <div class="g-top">
          <div class="g-block b-small"></div>
          <div class="g-block b1"></div>
          <div class="g-block b1"></div>
          <div class="g-block b1"></div>
          <div class="g-block b1"></div>
        </div>
        <div class="g-top stage">
          <div class="g-block b-small"></div>
          <div class="g-block b2"></div>
        </div>
        <div class="g-top act">
          <div class="g-block b-small"></div>
          <div class="act-list">
            <div class="g-block b3"></div>
            <div class="g-block b4"></div>
            <div class="g-block b4"></div>
          </div>
        </div>
        <div class="g-block b5"></div>
      </div>

      <div class="content-wrap m3 m4">
        <div class="g-top stage">
          <div class="g-block b-small"></div>
          <div class="g-block b2"></div>
        </div>
        <div class="g-top act">
          <div class="g-block b-small"></div>
          <div class="act-list">
            <div class="g-block b4"></div>
            <div class="g-block b3"></div>
          </div>
        </div>
      </div>

      <div class="s-bottom">
        <div class="s-icon">
          <div class="g-block top"></div>
          <div class="g-block bottom"></div>
        </div>
        <div class="s-icon">
          <div class="g-block top"></div>
          <div class="g-block bottom"></div>
        </div>
        <div class="s-icon">
          <div class="g-block top"></div>
          <div class="g-block bottom"></div>
        </div>
        <div class="s-btn-group">
          <div class="left"></div>
          <div class="right"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Skeleton',
  props: {
    className: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>
<style lang="scss" scoped src="../../index/index.scss"></style>
